import { render } from "./ModalFactory.vue?vue&type=template&id=134ce674&scoped=true&ts=true"
import script from "./ModalFactory.vue?vue&type=script&lang=ts"
export * from "./ModalFactory.vue?vue&type=script&lang=ts"

import "./ModalFactory.vue?vue&type=style&index=0&id=134ce674&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-134ce674"]])

export default __exports__